<div class="multi-camera-container">
  <div
    [ngStyle]="getGridStyle()"
    class="camera-grid"
    [class.single-camera]="streams?.length === 1"
    [class.few-cameras]="streams?.length > 1 && streams?.length < 4"
    [class.popup-mapa-mode]="popupMapa"
  >
    @for (stream of streams; track stream.camara._id + stream.canal) {
      <div
        class="irx-clickeable camera-container"
        role="button"
        tabindex="0"
        (click)="onStreamClick(stream)"
        (keydown.enter)="onStreamClick(stream)"
        [class.no-header]="popupMapa"
      >
        @if (!popupMapa) {
          <div class="camera-header">
            <span class="camera-name">
              {{ stream.camara.identificacion }}
              @if (
                stream?.camara?.canales && stream?.camara?.canales?.length > 1
              ) {
                - Canal {{ stream.canal }}
              }
            </span>
          </div>
        }

        <div class="camera-content" [class.no-min-height]="popupMapa">
          <!-- Grilla: sub-stream (baja res, generalmente H.264). Main solo en vista maximizada. -->
          <app-camera-player
            [idCamara]="stream.camara._id"
            [canal]="stream.canal"
            [fecha]="stream.recordDate"
            [mainStream]="false"
          ></app-camera-player>
        </div>
      </div>
    }
  </div>

  @if (streams?.length === 0) {
    <div class="no-cameras">
      <span class="material-icons">videocam_off</span>
      <p>No hay cámaras para mostrar</p>
    </div>
  }
</div>
